<template>
    <div id="pembayaran">
        <ol class="breadcrumb pull-right">
            <li><router-link :to="{ path: '/' }">Home</router-link></li>
            <li>Pembayaran</li>
            <li class="active">List Ticket Usage</li>
        </ol>

        <h1 class="page-header">List Ticket Usage</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">List Ticket Usage</h4>
                    </div>

                    <div class="panel-body">
                        <app-datatable
                            :items="ticketUsageList"
                            :headers="headers"
                            :has-action="false"
                            :has-custom-search="true"
                            :has-custom-pagination="true"
                            :custom-pagination-current-page="
                                pagination.currentPage
                            "
                            :custom-pagination-per-page="pagination.perPage"
                            :custom-pagination-total-pages="
                                pagination.totalPages
                            "
                            :custom-pagination-sort-mode="pagination.sortMode"
                            v-on:selected="selectedRow = $event"
                            v-on:dblClicked="detailTicketUsage()"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                            v-on:changeSortMode="
                                pagination = { ...pagination, sortMode: $event }
                            "
                            v-on:doSearch="
                                search = {
                                    query: $event.value,
                                    by: headersKey[$event.key],
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </div>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "ticket-usage",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            ticketUsageList: [],
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                "Title",
                "Type",
                "Username",
                "Email",
                "Ticket",
                "Used Ticket",
                "Created At",
            ],
            headersKey: [
                "title",
                "type",
                "user_name",
                "user_email",
                "ticket",
                "value",
                "createdAt",
            ],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },

        search: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = this.search;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            this.isLoading = true;

            SalesService.getTicketUsageList(pagination, search, (result) => {
                context.ticketUsageList = [];
                context.isLoading = false;

                if (result.success) {
                    if (result.data.length > 0) {
                        result.data.forEach((content) => {
                            var row = {
                                id: content.id,
                                data: [
                                    content.title || "-",
                                    content.type || "-",
                                    content.user_name || "-",
                                    content.user_email || "-",
                                    content.ticket || "-",
                                    content.value || "-",
                                    Moment(content.created_at).format(
                                        "YYYY-MM-DD",
                                    ) || "-",
                                ],
                                status: [content.status || "-"],
                            };

                            context.pagination.totalPages = content.page;
                            context.ticketUsageList.push(row);
                        });
                    }
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },

        detailTicketUsage: function () {
            var queryId = this.selectedRow.id;
            this.$router.push({
                path: "/ticket-usage/detail",
                query: { id: queryId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// TicketUsage.vue?b451d0a4